import { useGT } from 'gt-react';
import type { TaskOutcomeField } from '@erp/shared-types';

type FieldType = TaskOutcomeField['type'];

export function useFieldTypeLabels(): Record<FieldType, string> {
  const gt = useGT();
  const context = 'task outcome result field data type';
  return {
    text: gt('Text', { context }),
    textarea: gt('Long text', { context }),
    number: gt('Number', { context }),
    boolean: gt('Yes / No', { context }),
    select: gt('Choice', { context }),
    date: gt('Date', { context }),
  };
}

export function useFieldTypeLabel(): (type: FieldType) => string {
  const labels = useFieldTypeLabels();
  return (type) => labels[type];
}
